module.exports = __webpack_public_path__ + "img/cs3.97c490de.png";